"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _link = _interopRequireDefault(require("./core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Page Not Found"), /*#__PURE__*/_react.default.createElement("p", null, "The page you requested could not be found. You could try returning to the ", /*#__PURE__*/_react.default.createElement(_link.default, {
  to: "/"
}, "Home Page"), "."));
function render({
  staticContext
}) {
  if (staticContext) {
    staticContext.status = 404;
  }
  return _ref;
}
var _ref2 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  render: render
});
var _default = () => _ref2;
exports.default = _default;